import React, { useState, useEffect } from 'react';
import { TextField } from '@mui/material';
import {
  Label,
  BaseLabel,
  RowContainer,
  ImportButton,
  InputHalf,
  InputSmall,
  AutoCompleteSmall,
} from '../../../styles/styleUtils';


function formatDateToInputValue(date) {
  const localDate = new Date(date);
  localDate.setMinutes(localDate.getMinutes() - localDate.getTimezoneOffset()); // Corrige fuso
  return localDate.toISOString().split('T')[0];
}

function AddressData({ formData, onInputChange, onSearchCEP, setFormData }) {
  const [estados, setEstados] = useState([]);
  const [cidades, setCidades] = useState([]);

  useEffect(() => {
    fetchEstados();
  }, []);
  const fetchEstados = async () => {
    fetch('https://servicodados.ibge.gov.br/api/v1/localidades/estados')
      .then((response) => {
        if (!response.ok) {
          throw new Error('Erro na solicitação');
        }
        return response.json();
      })
      .then((estados) => {
        const estadosOrdenados = estados.sort((a, b) => a.nome.localeCompare(b.nome));
        setEstados(estadosOrdenados);
      })
      .catch((error) => {
        console.error('Erro ao obter os estados:', error);
      });
  };

  useEffect(() => {
    fetchCidades();
  }, [formData.estadoSigla]);
  const fetchCidades = () => {
    if (formData.estadoSigla) {
      fetch(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${formData.estadoSigla}/municipios`)
        .then((response) => {
          if (!response.ok) {
            throw new Error('Erro na solicitação');
          }
          return response.json();
        })
        .then((cidades) => {
          const cidadesOrdenados = cidades.sort((a, b) => a.nome.localeCompare(b.nome));
          setCidades(cidadesOrdenados);
        })
        .catch((error) => {
          console.error('Erro ao obter os estados:', error);
        });
    }
  };

  const changeEstado = (value) => {
    if (value) {
      setFormData((prev) => ({ ...prev, estado: value, estadoSigla: estados.find((e) => e.nome === value).sigla }));
    }
  };

  const changeCidade = (value) => {
    setFormData((prev) => ({ ...prev, cidade: value }));
  };

  return (
    <div>
      <RowContainer>
        <BaseLabel htmlFor="dataPrimeiraParcela">Data</BaseLabel>
        <InputSmall
          type="date"
          id="data"
          name="data"
          value={formatDateToInputValue(formData.data)}
          onChange={onInputChange}
          disabled={formData.visualiza}
        />
      </RowContainer>
      <RowContainer>
        <BaseLabel htmlFor="CEP">CEP</BaseLabel>
        <InputSmall type="text" id="cep" name="cep" value={formData.cep} onChange={onInputChange} />
        <ImportButton onClick={onSearchCEP}>Buscar CEP</ImportButton>
      </RowContainer>
      <RowContainer>
        <BaseLabel htmlFor="endereco">Endereço</BaseLabel>
        <InputHalf type="text" id="endereco" name="endereco" value={formData.endereco} onChange={onInputChange} />
        <span />
        <span />
        <span />
        <Label htmlFor="numero">Número</Label>
        <InputSmall type="text" id="numero" name="numero" value={formData.numero} onChange={onInputChange} />
        <span />
        <span />
        <span />
        <Label htmlFor="bairro">Bairro</Label>
        <InputSmall type="text" id="bairro" name="bairro" value={formData.bairro} onChange={onInputChange} />
      </RowContainer>
      <RowContainer>
        <BaseLabel htmlFor="complemento">Complemento</BaseLabel>
        <InputHalf
          type="text"
          id="complemento"
          name="complemento"
          value={formData.complemento}
          onChange={onInputChange}
        />
        <div style={{ width: 20 }} />
        <Label htmlFor="estado">Estado</Label>
        <AutoCompleteSmall
          disablePortal
          id="estado"
          name="estado"
          value={formData.estado || null} // string aqui (ex: 'Minas Gerais')
          onChange={(_, value) => changeEstado(value)}
          options={estados.map((e) => e.nome)} // transforma a lista de objetos em lista de strings (nomes)
          isOptionEqualToValue={(option, value) => option === value} // agora ambos são strings
          getOptionLabel={(option) => option} // option já é string
          renderInput={(params) => <TextField {...params} placeholder="Estado" />}
        />
        <div style={{ width: 20 }} />
        <Label htmlFor="cidade">Cidade</Label>
        <AutoCompleteSmall
          disablePortal
          id="cidade"
          name="cidade"
          value={formData.cidade || null} // string aqui (ex: 'Minas Gerais')
          onChange={(_, value) => changeCidade(value)}
          options={cidades.map((e) => e.nome)} // transforma a lista de objetos em lista de strings (nomes)
          isOptionEqualToValue={(option, value) => option === value} // agora ambos são strings
          getOptionLabel={(option) => option} // option já é string
          renderInput={(params) => <TextField {...params} placeholder="Cidade" />}
        />
      </RowContainer>
    </div>
  );
}

export default AddressData;
